import { rulesGenerators } from '~/core/utils/rulesGenerators'

const rulesCis = [
  (v: string) => v === null || !v || (/^\p{L}+(?:[ '-]\p{L}+)*$/u).test(v.trim()) || !v.trim() || 'Только буквы, дефис, пробел и апостроф',
  (v: string) => (v?.trim().length >= 1 && v.trim().length <= 100) || 'От 1 до 100 символов',
]

export const patronymicOptionalRulesCis = [
  rulesGenerators.required('Заполните поле или отметьте, что отчества нет'),
  ...rulesCis,
]

export const nameRulesCis = [
  rulesGenerators.required(),
  ...rulesCis,
]

export const surnameRulesCis = [
  rulesGenerators.required(),
  ...rulesCis,
]
